/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConversationCompleteWebhookPayload } from '../../models/conversation-complete-webhook-payload';

export interface PostConversationCompleteWebhookSchema$Params {
}

export function postConversationCompleteWebhookSchema(http: HttpClient, rootUrl: string, params?: PostConversationCompleteWebhookSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<ConversationCompleteWebhookPayload>> {
  const rb = new RequestBuilder(rootUrl, postConversationCompleteWebhookSchema.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConversationCompleteWebhookPayload>;
    })
  );
}

postConversationCompleteWebhookSchema.PATH = '/api/webhooks/notifications/events/ConversationComplete';
